export default "__VITE_ASSET__Dma8wJ24__"